"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/separator.ts
var _separator = require('@ariakit/react-core/separator/separator');



exports.Separator = _separator.Separator;
